import { render, staticRenderFns } from "./ADataTable.vue?vue&type=template&id=17fd35eb&scoped=true&"
import script from "./ADataTable.vue?vue&type=script&lang=js&"
export * from "./ADataTable.vue?vue&type=script&lang=js&"
import style0 from "./ADataTable.vue?vue&type=style&index=0&id=17fd35eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fd35eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
